// Gerado por scripts/build-icons.mjs — não editar manualmente.
import { createBankIcon } from "../createBankIcon";

/** Brex */
export const Brex = createBankIcon({
  name: "Brex",
  slug: "brex",
  compe: null,
  color: "#ffffff",
  viewBox: "0 0 100.03096 100.03096",
  html: "<rect\n     style=\"fill:#ffffff;fill-opacity:1\"\n     id=\"brex_rect1\"\n     width=\"100.03096\"\n     height=\"100.03096\"\n     x=\"0\"\n     y=\"0\" />\n  <g transform=\"translate(21.0155,21.0167) scale(2.41667)\">\n    <path d=\"M18.69 2.319a3.868 3.868 0 0 0-3.108 1.547l-.759 1.007a1.658 1.658 0 0 1-1.313.656H0V21.68h5.296a3.87 3.87 0 0 0 3.108-1.547l.759-1.006a1.656 1.656 0 0 1 1.313-.657H24V2.319h-5.31Zm1.108 11.949h-5.66a3.87 3.87 0 0 0-3.108 1.547l-.759 1.007a1.658 1.658 0 0 1-1.313.656H4.202V9.731h5.661a3.868 3.868 0 0 0 3.107-1.547l.759-1.006a1.658 1.658 0 0 1 1.313-.657h4.771l-.015 7.747Z\" style=\"fill:#212121\" fill-rule=\"evenodd\" />\n  </g>",
});
